"use strict";

exports.__esModule = true;
exports.systemProps = exports.styledProps = exports.isStyleProp = void 0;

var _styledSystem = require("@manifest-ui/styled-system");

const styledProps = (0, _styledSystem.compose)(_styledSystem.background, _styledSystem.border, _styledSystem.color, _styledSystem.flexbox, _styledSystem.grid, _styledSystem.layout, _styledSystem.other, _styledSystem.position, _styledSystem.shadow, _styledSystem.space, _styledSystem.transition, _styledSystem.typography);
exports.styledProps = styledProps;
const systemProps = [...styledProps.propNames];
exports.systemProps = systemProps;

const isStyleProp = prop => systemProps.includes(prop);

exports.isStyleProp = isStyleProp;